module.exports = __webpack_public_path__ + "static/media/ic_nav_01_selected.3c72e5f8.svg";